import React from 'react';
import { CrownIcon } from 'lucide-react';
import { footerLegal, footerNote } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/5 bg-night-800 py-12 md:py-14" data-id="element-71" data-mp="3ggu1qsai619z">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-72" data-mp="32p5m4f11ouo9">
        <p className="inline-flex items-center gap-2.5 font-display text-base font-bold uppercase tracking-[0.22em] text-gold-400" data-id="element-73" data-mp="36oo9dhgc9hu9">
          <CrownIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-74" data-mp="3ufjvbxy45itl" />
          El Código de Autoridad
        </p>

        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-faint" data-id="element-75" data-mp="36d44znhyxod">{footerNote}</p>

        <p className="mt-8 border-t border-white/5 pt-6 text-sm text-faint" data-id="element-76" data-mp="3lgop4lv2k8qa">{footerLegal}</p>
      </div>
    </footer>;
}